import EventPost from 'flarum/forum/components/EventPost';
import { STATUS_ICONS, statusLabel, ticketGuest } from '../../../common/utils/tickets';

/**
 * System post: "admin changed the status from Open to Resolved."
 */
export default class TicketStatusChangedPost extends EventPost {
  icon() {
    const [, status] = this.attrs.post.content();
    return STATUS_ICONS[status] || 'fas fa-ticket';
  }
  description(data) {
    // Reopened by a guest's reply: no user, show the guest's name.
    const guest = !data.user && ticketGuest(this.attrs.post.discussion());
    if (guest) data.username = guest.name;
    return super.description(data);
  }
  descriptionKey() {
    return 'soup-97-support.forum.post_stream.status_changed_text';
  }
  descriptionData() {
    const [from, to] = this.attrs.post.content();
    return {
      from: m("strong", null, statusLabel(from)),
      to: m("strong", null, statusLabel(to))
    };
  }
}
flarum.reg.add('soup-97-support', 'forum/components/posts/TicketStatusChangedPost', TicketStatusChangedPost);